import React from "react";
import "./App.scss";
import { Switch, Route, Redirect } from "react-router-dom";
import NavBar from "./components/navbarComponent/navbarComponent";
import HomePage from "./pages/home/homePage";
import AboutPage from "./pages/about/aboutPage";
// import PortfolioPage from "./pages/portfolio/portfolioPage";
import BlogPage from "./pages/blog/blogPage";

function App() {
  return (
    <>
      <NavBar />
      <Switch>
        <Route path="/home" render={(props) => <HomePage {...props} />} />
        <Route path="/about" render={(props) => <AboutPage {...props} />} />
        {/* <Route path="/portfolio" render={(props) => <PortfolioPage {...props} />} /> */}
        <Route path="/blog" render={(props) => <BlogPage {...props} />} />
        <Redirect from="/" exact to="/home" />
        <Redirect from="*" to="/home" />
      </Switch>
    </>
  );
}

export default App;
